import React from 'react';
import MUIGrid from '@mui/system/Unstable_Grid';
import { GridProps } from './Grid.types';
import { SxProps, Theme } from '@mui/system';

const Column = React.forwardRef(
  (
    { children, sx, className, ...props }: GridProps,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    return (
      <MUIGrid
        ref={ref}
        component='div'
        className={`cms-column ${className}`}
        sx={sx as SxProps<Theme>}
        {...props}
      >
        {children}
      </MUIGrid>
    );
  },
);

export default Column;
